import {BillboardCollection} from 'cesium';
import {Position} from '@turf/turf';
import {EnvironmentConfiguration} from '../EnvironmentConfiguration';
import {pointInsideBbox} from '../tools';
import {PlanEntity} from '../entities/plan.entity';
import {PlanLayer} from './layers/default/picto.layer';

export function setPlanBillboardSizes(billboardCollection: BillboardCollection, iconSize): void {
  const len = billboardCollection.length;
  const labelOffset = new Cesium.Cartesian2(-(iconSize / 2), -(iconSize / 20));

  for (let i = 0; i < len; ++i) {
    const b = billboardCollection.get(i);

    const isPicto = b.id.includes('picto_');

    if (isPicto) {
      b.height = iconSize;
      b.width = iconSize;
    } else {
      b.height = iconSize * .7;
      b.width = iconSize * .7;
      b.pixelOffset = labelOffset;
    }
  }
}

export function getLineColor(alias: string): any {
  switch (alias) {
    case 'itineraire_evacuation':
      return Cesium.Color.LIME;
    case 'deneigement':
      return Cesium.Color.WHITE;
    default:
      return Cesium.Color.RED;
  }
}

export function getIconUrl(feature): string {
  let bordure = '';

  if (feature.properties.priority === 'Elevée') {
    bordure = `?has_border=true&border=f1c40f&border_width=20`;
  }

  return `${EnvironmentConfiguration.urls.picto}picto/plan/${feature.properties.alias}/128.png${bordure}`;
}

export function createPlanPicto(feature, iconSize, viewer, height = 0): any {
  const coordinates = feature.geometry.coordinates as Position;

  return {
    id: `picto_${feature.properties.alias}_${feature.properties.fid}`,
    position: Cesium.Cartesian3.fromDegrees(Number(coordinates[0]), Number(coordinates[1]), height),
    image: getIconUrl(feature),
    height: iconSize,
    width: iconSize,
    disableDepthTestDistance: Number.POSITIVE_INFINITY,
    verticalOrigin: Cesium.VerticalOrigin.CENTER,
    pixelOffset: new Cesium.Cartesian2(0, 0),
    eyeOffset: new Cesium.Cartesian3(0, 0, 1000),
    scale: viewer.scene.mode === Cesium.SceneMode.SCENE3D ? 1 : 0.4,
    alias: feature.properties.alias,
    num: feature.properties.num,
  };
}

export function createPlanLabel(feature, img, iconSize, viewer, height = 0): any {
  const coordinates = feature.geometry.coordinates as Position;

  return {
    position: Cesium.Cartesian3.fromDegrees(Number(coordinates[0]), Number(coordinates[1]), height),
    id: `num_${feature.properties.num}_${feature.properties.fid}`,
    image: img,
    verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
    height: iconSize * 0.7,
    width: iconSize * 0.7,
    eyeOffset: new Cesium.Cartesian3(0, 0, 1000),
    disableDepthTestDistance: Number.POSITIVE_INFINITY,
    pixelOffset: viewer.scene.mode === Cesium.SceneMode.SCENE3D
      ? new Cesium.Cartesian2(-(iconSize / 2), -(iconSize / 20))
      : new Cesium.Cartesian2(-3, -(iconSize / 20)),
    scale: viewer.scene.mode === Cesium.SceneMode.SCENE3D ? 1 : 0.4,
  };
}

export function createPlanLine(feature): any {
  const coordinates = feature.geometry.coordinates as Position[];

  return {
    id: `line_${feature.properties.fid}`,
    polyline: {
      positions: Cesium.Cartesian3.fromDegreesArray(coordinates.flat(5)),
      clampToGround: true,
      material: getLineColor(feature.properties.alias),
      width: 4
    },
    properties: {
      alias: feature.properties.alias,
      num: feature.properties.num
    }
  };
}


export function getVisiblesPlanMarkersFromCurrentViewbox(layer: PlanLayer, bbox: any[]): Array<number> {
  const selectedEntity = [];

  Array.from(layer.entities.values()).forEach((entity: PlanEntity) => {
    if (entity.show && entity.coordinates.some((coord: Position[]) => pointInsideBbox(coord, bbox))) {
      selectedEntity.push(entity.num);
    }
  });

  return Array.from(new Set(selectedEntity));
}
